import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const PUBLISHER_NAME_REGEX = /^[a-zA-Z0-9_-]+$/;

const ApiKeyForm = ({ formData, handleInputChange, onSubmit }) => {
    const publisherNameError =
        formData.publisherName.length > 0 && !PUBLISHER_NAME_REGEX.test(formData.publisherName)
            ? 'Publisher Name may only contain letters, numbers, dashes, and underscores (no spaces).'
            : '';

    const handleSubmit = () => {
        if (publisherNameError || !formData.publisherName || !PUBLISHER_NAME_REGEX.test(formData.publisherName)) return;
        onSubmit();
    };

    return (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxWidth: 500,
                margin: '32px auto',
                padding: 3
            }}
        >
            <TextField
                label="Publisher Name. It must be unique across all publishers."
                name="publisherName"
                value={formData.publisherName}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
                error={!!publisherNameError}
                helperText={publisherNameError}
            />
            <TextField
                label="Label Alias"
                name="labelAlias"
                value={formData.labelAlias}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
                helperText="Auto-generated from Publisher Name. You may override it."
            />
            <TextField
                label="Label Text"
                name="labelText"
                value={formData.labelText}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
            />
            <TextField
                label="List of Accounts"
                name="accounts"
                value={formData.accounts}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
                multiline
                rows={3}
            />
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <TextField
                    label="Rank of Publisher"
                    name="rank"
                    value={formData.rank}
                    onChange={handleInputChange}
                    variant="outlined"
                    fullWidth
                    required
                    type="number"
                    slotProps={{
                        htmlInput: {
                            min: 0,
                            max: 10,
                            step: 1
                        }
                    }}
                />
                <Tooltip
                    title={
                        <div>
                            <div><strong>0</strong> - Key is associated with an OEM publisher</div>
                            <div><strong>1-4</strong> - Key is associated with an OEM regional publisher</div>
                            <div><strong>5</strong> - Key is associated with a group publisher</div>
                            <div><strong>6-9</strong> - Key is associated with a sub-group publisher</div>
                            <div><strong>10</strong> - Key is associated with a child site publisher</div>
                        </div>
                    }
                    arrow
                    placement="right"
                >
                    <IconButton
                        sx={{
                            marginTop: '8px',
                            color: '#1976d2'
                        }}
                    >
                        <InfoOutlinedIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <TextField
                label="Publisher Contact's Name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
            />
            <TextField
                label="Publisher Contact's Email Address"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
                type="email"
            />
            <Button
                sx={{
                    marginTop: 2,
                    backgroundColor: 'green',
                    '&:hover': { backgroundColor: 'darkgreen' }
                }}
                variant="contained"
                onClick={handleSubmit}
            >
                Generate API Key
            </Button>
        </Box>
    );
};

export default ApiKeyForm;
